export function mainNav() {
    const menuBtn = $(".menu-btn");
    const mainNav = $(".main-nav");
    const mainWrap = $("html");
    menuBtn.on("click", function () {
        mainWrap.toggleClass("no-scroll");
        $(this).toggleClass("active");
        mainNav.toggleClass("active");
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/mainNav.js